import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import { AuthProvider } from "./store/contexts/auth.context";
import { BrowserRouter } from "react-router-dom";
import { UIProvider } from "./store/contexts/ui.context";
import { PostsProvider } from "./store/contexts/posts.context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <UIProvider>
      <AuthProvider>
        <PostsProvider>
          <App />
        </PostsProvider>
      </AuthProvider>
    </UIProvider>
  </BrowserRouter>
);
